module.exports = __webpack_public_path__ + "img/eoy-impact-1.185d6d88.jpg";